import React from 'react'
import { Helmet } from 'react-helmet'

import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'

export const GoogleTagManager: React.FC<{}> = () => {
  const hasConsent = useHasConsent(['analytics', 'thirdparty'], 'any')
  if (isUnderTest()) return
  const googleTagId = process.env.GOOGLE_TAG_ID

  return hasConsent && googleTagId ? (
    <Helmet>
      <script
        async={true}
        src={`https://www.googletagmanager.com/gtag/js?id=${googleTagId}&l=googleDataLayer`}
      />
      <script type={'text/javascript'}>
        {`window.googleDataLayer = window.googleDataLayer || [];
          function gtag(){googleDataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleTagId}');`}
      </script>
    </Helmet>
  ) : null
}
